export default "__VITE_ASSET__BzyjKtz0__"